module.exports = __webpack_public_path__ + "bdc44fc18356dcd37053ee1a975767b9.pdf";